import { render, staticRenderFns } from "./HeaderNew.vue?vue&type=template&id=7d877057&scoped=true&"
import script from "./HeaderNew.vue?vue&type=script&lang=js&"
export * from "./HeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNew.vue?vue&type=style&index=0&id=7d877057&lang=scss&scoped=true&"
import style1 from "./HeaderNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d877057",
  null
  
)

export default component.exports